import { LeaveModalProps } from 'models/Hospital/viewDetailDiagnosisPageTypes';
import styled from 'styled-components';
import { MobileModalContent, MobileModalLayout, MobileModalLeftTitle, ModalBackground, ModalFooter } from './ModalForms';
import MobileBasicButton from 'components/Buttons/MobileBasicButton';
import { BorderColor } from 'styles/Global/colorSemantic';

const MobileLeaveModal = ({
    setIsLeaveModal,
    clickLeaveButtonInLeaveModal,
    title,
    subTitle,
    content,
    infoContents,
    infoContentsPadding,
    infoContentsBorderColor,
    infoContentsBorderRadius,
    firstButton,
    secondButton,
    firstButtonType = 'anotherFill',
    secondButtonType = 'warning',
}: LeaveModalProps) => {
    return (
        <ModalBackground $type='mobile'>
            <MobileModalLayout $width='300px'>
                <ModalTitleAndContentContainer>
                    <TitleWrapper>
                        <MobileModalLeftTitle>{title}</MobileModalLeftTitle>
                        <MobileModalLeftTitle>{subTitle}</MobileModalLeftTitle>
                    </TitleWrapper>
                    <MobileModalContent>{content}</MobileModalContent>
                    {infoContents && (
                        <ContentsInfoContainer $padding={infoContentsPadding} $borderColor={infoContentsBorderColor} $borderRadius={infoContentsBorderRadius}>
                            {infoContents}
                        </ContentsInfoContainer>
                    )}
                </ModalTitleAndContentContainer>
                <ModalFooter>
                    <MobileBasicButton $width='100%' $height='52px' onClick={setIsLeaveModal} $type={firstButtonType}>
                        {firstButton}
                    </MobileBasicButton>
                    {secondButton && (
                        <MobileBasicButton $width='100%' $height='52px' onClick={clickLeaveButtonInLeaveModal} $type={secondButtonType}>
                            {secondButton}
                        </MobileBasicButton>
                    )}
                </ModalFooter>
                {/* <CloseButtonWrapper onClick={setIsLeaveModal}>
                    <CloseDialogue />
                </CloseButtonWrapper> */}
            </MobileModalLayout>
        </ModalBackground>
    );
};

export default MobileLeaveModal;

const ModalTitleAndContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 10px;
`;

const TitleWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
`;

const ContentsInfoContainer = styled.div<{ $padding?: string; $borderColor?: string; $borderRadius?: string }>`
    display: flex;
    width: 100%;
    flex-direction: column;
    border-radius: ${(props) => props.$borderRadius ?? '8px'};
    padding: $padding;
    border: ${(props) => (props.$borderColor ? `1px solid ${props.$borderColor}` : `1px solid ${BorderColor.color_border_neutral}`)};
    padding: ${(props) => props.$padding ?? '16px 14px'};
`;
